// @flow

import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

export default class TipTooltip extends Component {

  static Placement = {
    TOP: 'top',
    LEFT: 'left',
    RIGHT: 'right',
    BOTTOM: 'bottom'
  };

  static propTypes = {
    text: PropTypes.string.isRequired,

    placement: PropTypes.string
  };

  static defaultProps = {
    placement: TipTooltip.Placement.TOP
  };


  render() {
    const tooltip = <Tooltip id="tip-tooltip">{this.props.text}</Tooltip>;
    const className = this.props.className || "glyphicon glyphicon-question-sign"

    return (
        <OverlayTrigger placement={this.props.placement} overlay={tooltip}>
      <sup className="tip_tooltip">
        <i className={className} />
      </sup>
        </OverlayTrigger>
    );
  }
}
